export interface ITopOffenderFilterState {
  selectedRegion: string;
  selectedType: string;
  selectedStatus: string;
  selectedAlarmType: string;
  selectedConfigStatus: string;
}

export const topOffenderFilterInitialState: ITopOffenderFilterState = {
  selectedRegion: "",
  selectedType: "",
  selectedStatus: "",
  selectedAlarmType: "",
  selectedConfigStatus: "",
};
